import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDieSinkingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-white",
			points: "21.493 9.567 12.528 4.391 3.507 9.6 3.429 15.568 12.55 20.744 21.337 15.31 21.493 9.567"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M21.739,9.517a.189.189,0,0,0-.01-.035.251.251,0,0,0-.108-.137L12.656,4.17a.252.252,0,0,0-.256,0L3.379,9.378a.248.248,0,0,0-.109.139.207.207,0,0,0-.009.031l-.01,5.885a.255.255,0,0,0,.128.222l8.965,5.176a.261.261,0,0,0,.128.034.258.258,0,0,0,.128-.034l9.021-5.208a.258.258,0,0,0,.128-.222V9.568Zm-9.523,5.407v5.241l-8.452-4.88V10.044Zm7.356-4.544a.262.262,0,0,0-.094.1l-1.35,2.4-.5-.289a.258.258,0,0,0-.35.094.255.255,0,0,0,.093.349l.338.2-1.906,1.1L14.431,13.5a.257.257,0,0,0-.261,0l-1.7.981L4.02,9.6l8.508-4.912,8.452,4.88Zm-6.843,4.544,1.567-.906,1.376.824a.251.251,0,0,0,.26,0l2.42-1.4a.12.12,0,0,0,.038-.033.222.222,0,0,0,.045-.043l1.455-2.582,1.346-.778v5.242l-8.507,4.912Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M15.214,11.77h0a.26.26,0,0,0,.128.033.256.256,0,0,0,.129-.478l-.721-.419A.255.255,0,0,0,14.4,11a.257.257,0,0,0,.093.35Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M16.654,12.609h0a.274.274,0,0,0,.128.033.256.256,0,0,0,.129-.478l-.721-.42a.257.257,0,0,0-.256.445Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M13.085,10.59a1.645,1.645,0,0,1,.361.151l.328.192a.262.262,0,0,0,.128.033.256.256,0,0,0,.129-.478L13.7,10.3a2.186,2.186,0,0,0-.474-.2.256.256,0,0,0-.144.492Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M12.331,9.978a2.968,2.968,0,0,0-.9.147.254.254,0,0,0-.149.129.256.256,0,0,0,.23.37.225.225,0,0,0,.082-.014,2.5,2.5,0,0,1,.74-.12.252.252,0,0,0,.181-.077.262.262,0,0,0,.073-.182A.258.258,0,0,0,12.331,9.978Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M10.215,7.64a.285.285,0,0,0-.377-.135c-.1.049-.207.1-.307.16a3.551,3.551,0,0,0-.459.314.284.284,0,0,0,.359.439,2.935,2.935,0,0,1,.384-.262c.084-.048.173-.1.265-.138A.285.285,0,0,0,10.215,7.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M9.115,10.21a.283.283,0,1,0-.443.353,2.845,2.845,0,0,0,.692.61.286.286,0,0,0,.153.044A.284.284,0,0,0,9.67,10.7,2.248,2.248,0,0,1,9.115,10.21Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M12.388,7.546a6.48,6.48,0,0,1,.793.051.171.171,0,0,0,.039,0,.283.283,0,0,0,.036-.564,6.924,6.924,0,0,0-.867-.057.284.284,0,1,0,0,.567Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M10.377,11.11a.283.283,0,0,0-.285.49l.721.42a.285.285,0,0,0,.142.038.283.283,0,0,0,.143-.528Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M8.841,9.6a1.049,1.049,0,0,1-.008-.125,1.088,1.088,0,0,1,.134-.513.283.283,0,1,0-.5-.264,1.661,1.661,0,0,0-.2.777,1.6,1.6,0,0,0,.013.2.283.283,0,0,0,.281.247l.036,0a.289.289,0,0,0,.188-.107A.283.283,0,0,0,8.841,9.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M10.74,7.759a.257.257,0,0,0,.075-.01,5.759,5.759,0,0,1,.778-.154.284.284,0,0,0,.245-.317.285.285,0,0,0-.115-.194.274.274,0,0,0-.2-.051,6.1,6.1,0,0,0-.855.17.283.283,0,0,0,.074.556Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M17.125,8.774a.282.282,0,0,0-.388.1.286.286,0,0,0,.1.388l.721.42a.282.282,0,0,0,.142.038.283.283,0,0,0,.143-.528Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M19.286,10.032l-.721-.42a.283.283,0,0,0-.285.49l.721.42a.285.285,0,0,0,.388-.1A.285.285,0,0,0,19.286,10.032Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M15.683,7.937a.285.285,0,0,0-.387.1.285.285,0,0,0,.1.388l.722.417a.282.282,0,0,0,.142.038.283.283,0,0,0,.141-.528Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.113,7.209a.275.275,0,0,0-.213.024.283.283,0,0,0,.059.521,4.294,4.294,0,0,1,.732.275.281.281,0,0,0,.124.028.283.283,0,0,0,.268-.375.278.278,0,0,0-.145-.163A4.944,4.944,0,0,0,14.113,7.209Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M11.818,11.949a.281.281,0,0,0-.214-.029.279.279,0,0,0-.173.132.284.284,0,0,0,.1.387l.72.42a.3.3,0,0,0,.143.038.284.284,0,0,0,.142-.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M13.258,12.787a.283.283,0,0,0-.285.49l.415.242a.288.288,0,0,0,.142.038.283.283,0,0,0,.143-.528Z"
		})
	]
});
export default SvgDieSinkingSm;
